import { WaterfallStructure } from 'further-types/lp/carry-settings';

export const waterfallStructureLabels = {
  [WaterfallStructure.ReturnOfCapital]: 'Return of capital',
  [WaterfallStructure.PreferredReturn]: 'Preferred return',
  [WaterfallStructure.CarriedInterestPartnerCatchup]:
    'Carried interest partner catch-up',
  [WaterfallStructure.ExcessProceeds]: 'Excess proceeds',
};

export const waterfallStructureDescriptions = {
  [WaterfallStructure.ReturnOfCapital]:
    'Returns investors their paid-in capital.',
  [WaterfallStructure.PreferredReturn]:
    'Distributes each investor their preferred return.',
  [WaterfallStructure.CarriedInterestPartnerCatchup]:
    'Allocates proceeds to the carried interest partner until they are caught up with the investor preferred return.',
  [WaterfallStructure.ExcessProceeds]:
    'Remaining proceeds are split between the carry partner and investors in line with the agreed profit share.',
};
